import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyEx } from "@front/m19-models";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { StrategyListPreviewComponent } from "@m19-board/shared/strategy-list-preview/strategy-list-preview.component";

@Component({
  selector: "app-dsp-audience-in-use-modal",
  imports: [TranslocoDirective, StrategyListPreviewComponent, IButtonDirective],
  template: `<div *transloco="let t" class="flex flex-col gap-4 text-gray-800">
    <div class="flex flex-col gap-1">
      <div class="font-medium">
        {{ t("dsp-audiences.audience_in_use_by_n_strategies", { count: strategiesUsingAudience.length }) }}
      </div>
      <div class="text-sm text-gray-600">
        {{ t("dsp-audiences.audience_in_use_remove_from_strategies", { count: strategiesUsingAudience.length }) }}
      </div>
    </div>

    <div class="-mr-1 max-h-72 overflow-y-auto pr-1">
      <app-strategy-list-preview [strategies]="strategiesUsingAudience" />
    </div>

    <div class="flex justify-end">
      <button iButton variant="secondary" size="md" testId="btn-close" (click)="close()">
        {{ t("common.i_understand") }}
      </button>
    </div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspAudienceInUseModalComponent {
  private readonly modalData = inject<DspAudienceInUseModalData>(MODAL_DATA);
  private readonly modalRef = inject(ModalRef);

  protected readonly strategiesUsingAudience = this.modalData.strategiesUsingAudience;

  protected close(): void {
    this.modalRef.close();
  }
}

export interface DspAudienceInUseModalData {
  strategiesUsingAudience: StrategyEx[];
}
